
import { SEO } from '../../utils/seo';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import PropertyShowcase from './components/PropertyShowcase';
import TestimonialsSection from './components/TestimonialsSection';
import ContactSection from './components/ContactSection';
import Footer from '../../components/feature/Footer';
import GlobalNavbar from '../../components/feature/GlobalNavbar';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="El Paso Cash Home Buyers | TREX RE LLC - We Buy Houses Fast"
        description="TREX RE LLC buys houses, land, and distressed properties for cash in El Paso, TX. No commissions, no repairs needed, close in as fast as 7 days. Get your fair cash offer today."
        keywords="sell house fast El Paso, cash home buyers El Paso, we buy houses El Paso TX, sell my house for cash, TREX RE LLC"
        canonical="/"
        schema={{
          "@context": "https://schema.org",
          "@type": "RealEstateAgent",
          "name": "TREX RE LLC",
          "description": "We buy houses, land, and distressed properties for cash in El Paso, TX.",
          "url": "https://trexrealestate.com/",
          "telephone": "+1-915-206-5814",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "3016 Gull Lake Pl",
            "addressLocality": "El Paso",
            "addressRegion": "TX",
            "postalCode": "79936",
            "addressCountry": "US"
          }
        }}
      />
      <GlobalNavbar />
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <PropertyShowcase />
      <TestimonialsSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
